import { render, staticRenderFns } from "./importOrderList.vue?vue&type=template&id=0a6cc671&scoped=true&"
import script from "./importOrderList.vue?vue&type=script&lang=js&"
export * from "./importOrderList.vue?vue&type=script&lang=js&"
import style0 from "./importOrderList.vue?vue&type=style&index=0&id=0a6cc671&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6cc671",
  null
  
)

export default component.exports